module.exports = {"511424102":"仁美镇","511424106":"杨场镇","511424108":"张场镇","511424109":"齐乐镇","511424204":"顺龙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511424.json
// module id = 2484
// module chunks = 0